// ---------------------------------------------- modules import
import M from "materialize-css";
import React, { FunctionComponent, Fragment, useEffect } from "react";
import { Link } from "react-router-dom";

import { ISidebarProps } from "./common";
import { ThemeContext } from "../../contexts/themeContext";
import PermissionHelper from "../../store/helpers/permissionHelper";

// ---------------------------------------------- the component
const Sidebar: FunctionComponent<ISidebarProps> = ({ profile }) => {
  const { email, name, permissions } = profile;

  const menuGroups = PermissionHelper.toMenuGroups(permissions);

  // ---------------------------------------------- handlers
  const handleClick = () => {
    const sidenav = document.querySelector(".sidenav");

    if (sidenav) {
      const instance = M.Sidenav.getInstance(sidenav);

      instance.close();
    }
  };

  // ---------------------------------------------- effects
  useEffect(() => {
    const sidenav = document.querySelector(".sidenav");

    if (sidenav) M.Sidenav.init(sidenav);
  }, []);

  useEffect(() => {
    const collapsibles = document.querySelectorAll(".collapsible");

    if (collapsibles) M.Collapsible.init(collapsibles);
  }, []);

  // ---------------------------------------------- content
  return (
    <ThemeContext.Consumer>
      {({ theme }) => (
        <>
          <ul
            id="slide-out"
            className="sidenav collapsible"
            style={{ backgroundColor: theme.sidebar }}
          >
            <li>
              <div className="user-view">
                <div className="background">
                  <img src="images/user-view-bg.jpg" alt="user-view-bg" />
                </div>

                <span
                  className="btn-floating waves-effect waves-circle waves-light hoverable"
                  style={{ backgroundColor: theme.ui }}
                >
                  {name ? name.slice(0, 2).toUpperCase() : ""}
                </span>

                <span className="name" style={{ color: theme.text }}>
                  {name}
                </span>

                <span className="email" style={{ color: theme.text }}>
                  {email}
                </span>
              </div>
            </li>

            {menuGroups.map((menuGroup, index) => {
              const { name, icon, menus } = menuGroup;

              let isGroupShown = false;

              menus.forEach(menu => {
                isGroupShown = isGroupShown || menu.permission.view;
              });

              return isGroupShown ? (
                <li key={index}>
                  <div
                    className="collapsible-header waves-effect"
                    style={{ color: theme.text }}
                  >
                    <i className="material-icons" style={{ color: theme.icon }}>
                      {icon}
                    </i>

                    {name}
                  </div>

                  <div
                    className="collapsible-body"
                    style={{ backgroundColor: theme.sidebar }}
                  >
                    {menus.map((menu, index) => {
                      const { name, url, permission } = menu;

                      return permission.view ? (
                        <Fragment key={index}>
                          <Link
                            to={`/${url}`}
                            style={{
                              color: theme.text,
                              display: "block",
                              padding: "0 25px"
                            }}
                            onClick={handleClick}
                          >
                            {name}
                          </Link>

                          <div className="divider" />
                        </Fragment>
                      ) : null;
                    })}
                  </div>
                </li>
              ) : null;
            })}
          </ul>

          <a
            href="/"
            data-target="slide-out"
            className="sidenav-trigger"
            style={{ position: "absolute", top: "15px", left: "15px" }}
          >
            <i className="small material-icons" style={{ color: theme.syntax }}>
              menu
            </i>
          </a>
        </>
      )}
    </ThemeContext.Consumer>
  );
};

export default Sidebar;
